import React from 'react';
import Center from './Center';
import p from '../../static/app-store-badge.svg';
import { StyleSheet, css } from 'aphrodite';
import { Col, Row, Typography } from 'antd';
let styles = StyleSheet.create({
	background: {
		background: `#2f89fc`,
		textAlign: 'center',
		color: '#fff',
		padding: '5%',
	},
	h2: {
		fontSize: 'min(36px,3vw)',
		color: '#fff',
	},
	p: {
		fontSize: 'min(16px,2vw)',
	},
});
const Intro2 = () => {
	return (
		<div className={css(styles.background)}>
			<Center>
				<Typography.Title
					style={{
						color: '#fff',
					}}
				>
					Discover what all the buzz is about!
				</Typography.Title>
				<h2 className={css(styles.h2)}></h2>
				<Row gutter={200}>
					<Col span={24}>
						<Typography.Title
							level={4}
							style={{
								color: '#fff',
							}}
						>
							Our app is available on IOS devices! Download now to get started!
						</Typography.Title>
						<a href="https://itunes.apple.com/kw/app/meetain/id1089582421?mt=8">
							<img src={p} />
						</a>
					</Col>
				</Row>
			</Center>
		</div>
	);
};

export default Intro2;
